import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormControlLabel, Radio, styled, Typography, useTheme } from '@mui/material';
import useApplicationSettings from './useApplicationSettings';
import { useContext, useState } from 'react';
import { ThemeContext } from '@application/context/themeContext';
const presetColors = [
    '#0ea5e9',
    '#0e7fe9',
    '#f59e0b',
    '#06b6d4',
    '#f97316',
    '#3b82f6',
    '#ec4899',
    '#0284c7',
    '#2563eb'
];
const ColorBox = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'selected'
}) `
  width: 32px;
  height: 32px;
  border-radius: 6px;
  cursor: pointer;
  border: ${({ selected }) => (selected ? '2px solid #0ea5e9' : '2px solid transparent')};
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ApplicationSettings = () => {
    const mytheme = useTheme();
    const { mainContainerStyles, headerStyles } = useApplicationSettings();
    const [selectedColor, setSelectedColor] = useState('#0ea5e9');
    const [anchorEl, setAnchorEl] = useState(null);
    const themeContext = useContext(ThemeContext);
    if (!themeContext)
        return null;
    const { theme, setTheme } = themeContext;
    const handleColorClick = (color) => {
        setSelectedColor(color);
    };
    const handleCustomColorClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCustomColorChange = (color) => {
        setSelectedColor(color.hex);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    return (_jsx(Box, { sx: mainContainerStyles, children: _jsxs(Box, { sx: headerStyles, children: [_jsx(Typography, { variant: 'subtitle1', color: 'text.secondary', children: "Theme" }), _jsxs(Box, { display: 'flex', gap: '152px', children: [_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 1, children: [_jsx(FormControlLabel, { label: 'Light', labelPlacement: 'end', control: _jsx(Radio, { size: 'small', checked: theme === 'light', onChange: () => setTheme('light') }), sx: {
                                        '& .MuiFormControlLabel-label': {
                                            color: mytheme.palette.text.primary
                                        }
                                    } }), _jsx(Box, { width: '264px', height: '220px', children: _jsx("img", { src: '/assets/svgs/light-mode.svg', width: '100%', height: '100%', alt: 'light-mode' }) })] }), _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 1, children: [_jsx(FormControlLabel, { control: _jsx(Radio, { size: 'small', checked: theme === 'dark', onChange: () => setTheme('dark') }), label: 'Dark', labelPlacement: 'end', sx: {
                                        '& .MuiFormControlLabel-label': {
                                            color: mytheme.palette.text.primary
                                        }
                                    } }), _jsx(Box, { width: '264px', height: '220px', children: _jsx("img", { src: '/assets/svgs/dark-mode.svg', width: '100%', height: '100%', alt: 'dark-mode' }) })] })] })] }) }));
};
export default ApplicationSettings;
